import type { CustomFieldMapping } from "@/lib/types/itsm-import";

export function CustomFieldMappingsSummary({
  mappings,
}: {
  mappings: CustomFieldMapping[] | null | undefined;
}) {
  if (!mappings) {
    return <p>All fields on the Jira issue view → description</p>;
  }
  if (mappings.length === 0) {
    return <p>None (custom fields are not imported)</p>;
  }
  return (
    <ul className="mt-1 space-y-1">
      {mappings.map((m) => (
        <li key={m.source_field_id}>
          <span className="font-medium">
            {m.source_field_name ?? m.source_field_id}
          </span>{" "}
          <span className="text-muted-foreground font-mono text-xs">
            {m.source_field_id}
          </span>{" "}
          →{" "}
          {m.method === "harmony_custom_field" ? (
            <>
              Harmony field{" "}
              <span className="font-medium">{m.harmony_field_name}</span>
            </>
          ) : (
            "description"
          )}
        </li>
      ))}
    </ul>
  );
}
